import * as React from 'react';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/content';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';

const CmsWhitespace = ({ component  })=>{
    const { size  } = component.getParameters();
    if (!size) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: `whitespace whitespace--${size}`,
        "data-t": "cms-whitespace"
    });
};
var Whitespace = compose(withBreakpointVisibility, withAnchor)(CmsWhitespace);

export { CmsWhitespace, Whitespace as default };
//# sourceMappingURL=Whitespace.js.map
